import React from 'react';
import styled from 'styled-components';

const PodcastImage = ({ url, alt = '', size, className }) => {
  const Image = styled.img`
    display: block;
    border-radius: ${size === 'xs' ? '3px' : size === 'sm' ? '6px' : '12px'};
    max-width: ${size === 'xs'
      ? '20px'
      : size === 'sm'
      ? '50px'
      : size === 'full'
      ? 'initial'
      : '200px'};
    height: auto;
  `;

  return (
    <>
      <Image src={url} alt={alt} className={className} />
    </>
  );
};

export default PodcastImage;
